import {
  Box,
  BoxProps,
  CircularProgress,
  CircularProgressProps,
} from "@mui/material";
import { JSX } from "react";

type LoaderProps = BoxProps & {
  isCentered?: boolean;
  svgProps?: CircularProgressProps;
};

const centeredElement = {
  top: "50%",
  position: "absolute",
  left: "50%",
};

function Loader({
  sx,
  isCentered = true,
  svgProps = {},
  ...props
}: LoaderProps): JSX.Element {
  const centeredStyles = isCentered ? centeredElement : {};
  return (
    <Box sx={{ ...centeredStyles, ...sx }} {...props}>
      <CircularProgress {...svgProps} />
    </Box>
  );
}

export { Loader };
